module.exports = __webpack_public_path__ + "img/pan6.9d47f725.png";